import * as React from 'react';
import { Link, RouteComponentProps, BrowserRouter as Router,useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import {Filters, Pagination, constants, KeolisSpinner, moment} from './common/commonExport';
import * as actions from "../actions/index";
const keolisLogo= require('../../../src/assets/images/KeolisLogo.png');

import autoTable from 'jspdf-autotable';




class PDFPrinting extends React.Component{
    constructor(props) {
        super(props);
        this.state = { // default state for component
            params: this.props.Params,
            pageNumberInput:'',
            printStatus:false,
            filterState:{}
        
        }
    }
  
    render() {
        const { printStatus } = this.props.printState;
        let routeFrom = this.props.route;
        let hidden = this.props.hidden;
        let validWorkday = this.props ? this.props.validWorkday : '';
        let dutyActivityStatus = this.props.workday ? this.props.workday.dutyActivityStatus : '';
        const isModalOpened = this.props.showModal;
        return (
                <div className={"printContainer " + (printStatus || hidden || this.props.isLoading || (dutyActivityStatus == 'N' && !validWorkday && isModalOpened)  ? 'hidden' : '')}>

                {
                    routeFrom == constants.HISTORICAL_LOGS ?
                        <button className={"btn btnWidth btn-primary filterBtn"} onClick={this.fetchData.bind(this)}>PDF <i className="fa fa-print" aria-hidden="true"></i></button> 
                        :<button className={"btn btnWidth btn-primary filterBtn"} onClick={this.getData.bind(this)}>Summary <i className="fa fa-print" aria-hidden="true"></i></button>               
                                      


                }
                
                                
                </div>
                
                

        )
    }

    fetchData() {
        let filterFetchObj = this.props.fetchDataObj;
        let role = this.props.authDetails.role;
        let category = this.props.route;
        let self = this;
        this.props.fetchDataToPrint(filterFetchObj, function (data) {
            if (data) {
                self.printDetails(role, data, category, function () {
                    self.props.printProgress(false);
                });
            } else {
                self.props.printProgress(false);
            }
        });

    }


    // getting data to print
    getData() { 
        let isPre16 = this.props.details && this.props.details == "Pre16";
        let pageNo = this.props.pageNo;
        let duty_activity = this.props.data,
            role = this.props.authDetails.role;
        this.props.printProgress(true);  
        this.setState({
            printStatus:true
        }); 
        const route = localStorage.getItem('route');
        const filter = this.props.filterState;
        let filterObj =  filter;
         if(typeof(this.props.getSelectedCheckedData) ==='function')
         {
            const { getSelectedCheckedData } = this.props; 
            let selectedRows = getSelectedCheckedData();
            filterObj =  {selectedRows, ...filter};
         }

        
        
        let self = this,
            projectId = this.props.ProjectId,
            projectName = this.props.ProjectName,
            empId = this.props.authDetails.employeeID;
            
       let url = route == constants.ADMIN_HOS_LOG ? constants.actionUrls.ADMIN_HOS_LOGS_URL 
                    : route == constants.FRA_REPORT ? constants.actionUrls.GET_FRA_LIST 
                    : role == constants.roles.EMPLOYEE_ROLE ? constants.actionUrls.WORKDAY_URL 
                    : isPre16 ? constants.actionUrls.ADMIN_NCNP_URL 
                    : route == constants.SERIES14 ? constants.actionUrls.GET_ALL_USER_SERIES 
                    : constants.actionUrls.ADMIN_URL;
                    
        let fetchObj = {
            url:url,
            role: role,
            pageNum: pageNo ? pageNo : 1,
            certifyStatus:localStorage.getItem('route'),
            byPrint:true,
            filterObj:filterObj
        }
        let category = localStorage.getItem('route'),
            error = constants.errMessages.printError;
            if(typeof duty_activity == 'object'){
                var activitiesArr = Object.keys(duty_activity).map(function (k) {
                    return duty_activity[k];
                });
                duty_activity = activitiesArr;
            }
            if(role == constants.roles.EMPLOYEE_ROLE && duty_activity && duty_activity.length > 0){
                duty_activity = duty_activity.filter(function(activity){
                    if(activity.isDeleted != null || activity.isDeleted != true){
                        return activity.isDeleted != true;
                    } else if (activity.isEdited){
                        activity["dty_act_name"] = activity.dty_act_name_updated ? activity.dty_act_name_updated : activitiesArr.dty_act_name;
                        activity["dty_act_start_time"] = activity.dty_act_start_time_updated ? activity.dty_act_start_time_updated : activity.dty_act_start_time;
                        activity["dty_act_end_time"] = activity.dty_act_end_time_updated ? activity.dty_act_end_time_updated : activity.dty_act_end_time;
                        activity["dty_act_misc_time"] = activity.dty_adjusted_value_updated ? activity.dty_adjusted_value_updated : activity.dty_adjusted_value;
                        return activity;
                    }                    
                });
                if(duty_activity.length > 0){
                    self.printDetails(role, duty_activity, category, function(){ // printing triggered
                        self.props.printProgress(false); // print in progress state
                    });
                } else {
                    this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
                    this.props.printProgress(false); // print in progress state
                }                
            } else if(role != constants.roles.EMPLOYEE_ROLE) {
                if(fetchObj.certifyStatus == constants.OUTLAW){
                    fetchObj.filterObj['outlaw'] = true;
                    category = constants.UNCERTIFIED;
                }
                if(category == constants.ADMIN_HOS_LOG){
                    filterObj["menustatus"] = this.props.logStatus ? this.props.logStatus : '';
                    filterObj["greater12"] = this.props.greater12 ? '1' : '';
                }
    
                this.props.fetchDataToPrint(fetchObj, function(data){
                    if(data){
                        self.printDetails(role, data, category, function(){
                            self.props.printProgress(false);
                        });
                    } else {
                        self.props.printProgress(false);
                    }                    
                });
            } else {
                this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
                this.props.printProgress(false);
            }
            
    };


    getSelectedData()
      {

        this.getData();
    }

    getActivityTime(activity, timeProp){
        let activityTime;
        if(timeProp == 'endTime'){
            let activityEndTimeUpdated = activity.dty_act_end_time_updated,
                activityEndTime = activity.dty_act_end_time;
            activityTime = activityEndTimeUpdated ? activityEndTimeUpdated : activityEndTime;
        }else if(timeProp == 'miscTime'){
            let activityMiscTimeUpdated = activity.dty_adjusted_value_updated ? activity.dty_adjusted_value_updated : activity.dty_adjusted_value;
            activityTime = activityMiscTimeUpdated ? activityMiscTimeUpdated.replace(':','h') : '0h00';
        } else {
            let activityStartTimeUpdated = activity.dty_act_start_time_updated,
                activityStartTime = activity.dty_act_start_time;
            activityTime = activityStartTimeUpdated ? activityStartTimeUpdated : activityStartTime;
        }
        return activityTime.toUpperCase();
    }

    getStatus(project){
        // return project.dutyActivityStatus == 'N' ? 'OFF' : project.wdy_certify_status == constants.CERTIFIED ? "Certified" : 'Not Certified'
        let certifyTxt = project.dutyActivityStatus == 'N' ? 'OFF' : "Not Certified";
        if (project.wdy_certify_status == constants.UNCERTIFIED) {
            return certifyTxt;
        }
        else {
            return project.IsAmendment == '1' ? 'Amendment-' + project.AmendmentId +' ' : project.Created_By == 'system' ? 'Certified-s' : 'Certified';
        }
    }

    // print function
    printDetails(role, data, category, callback) {
        import("jspdf").then(({ jsPDF }) => {
            this.props.printProgress(true);
            let printTitle = 'HOS_' + this.props.compTitle,
                empDetailsFontSize = 10, pageTitle = this.props.compTitle;
            const { Orientation, Unit } = constants.PrintPDF;
            let doc = new jsPDF(Orientation, Unit),
                img = new Image(),
                empRole = role,
                today = moment().format("MM/DD/YY"),
                number_of_pages = doc.internal.getNumberOfPages();
            const totalPagesExp = '{total_pages_count_string}';
            let dataToPrint = data,
                printColumns = constants.PrintPDF.getPrintColumns(role, category), temp = [],
                printRows = [];
            if (role == constants.roles.EMPLOYEE_ROLE) { // for employee
                dataToPrint = dataToPrint;
                if (category == constants.HISTORICAL_LOGS) {
                    let printRows1 = dataToPrint.map((workday, index) => {                        
                       let serviceDate = workday.wdy_date,
                           type = workday.RestBreakNo == 1 ?
                               workday.IsAmendment == '1' ? 'Amendment-' + workday.AmendmentId : 'First Start'
                               : workday.RestBreakNo == 2 ? workday.IsAmendment == '1' ? 'Amendment-' + workday.AmendmentId : 'Second Start' : '',
                            totalHos = workday.wdy_working_time_hos_adjust && (workday.wdy_certify_status.trim() === 'C') ? workday.wdy_working_time_hos_adjust.toLowerCase().lastIndexOf('m') > 0 ? workday.wdy_working_time_hos_adjust : workday.wdy_working_time_hos_adjust.trim().toUpperCase() + 'M' : ""
                        let status = this.getStatus(workday);                       
                        temp = [serviceDate, type, totalHos, status];
                        printRows.push(temp);
                    })
                }
                else {
                    let printRows1 = dataToPrint.map((activity, index) => {
                        let activityName = activity.dty_act_name, startTime = this.getActivityTime(activity, 'startTime'),
                            endTime = this.getActivityTime(activity, 'endTime'),
                            miscTime = this.getActivityTime(activity, 'miscTime');

                        temp = [activityName, startTime, endTime, miscTime];
                        printRows.push(temp);
                    })
                }
            } else { // for admin
                if (category == constants.AUDIT_TRAIL) { // for admin audit
                    let printRows1 = dataToPrint.map((audit, index) => {
                        temp = [audit.ID, audit.adt_type.trim(), audit.adt_tbl_name, audit.adt_tabl_clm_name, audit.adt_old_value != null ? audit.adt_old_value.trim() : audit.adt_old_value,
                        audit.adt_new_value != null ? audit.adt_new_value.trim() : audit.adt_new_value, audit.adt_created_tsp];
                        printRows.push(temp);
                    });
                } else { // except audit
                    let printRows1 = dataToPrint.map((project, index) => {


                        let division = project.division ? project.division : '-', outlaw = '-';
                        if (category == constants.UNCERTIFIED || category == constants.CERTIFIED) {

                            outlaw = project.wdy_violates_hos_before == true ||
                                project.wdy_hos_11h59value == true ||
                                project.wdy_violates_hos_after == true ||
                                project.wdy_is_14_consec_day_respected == false ||
                                project.wdy_is_6_consec_day_respected == false;
                            let empId = project.demp_display_Id,
                                empFullName = project.emp_full_name, wdy_date = project.wdy_date,
                                phone = project.wdy_emp_phone_numbers, hos = project.wdy_spread,
                                tos = project.wdy_working_time_hos, certifyDate = project.wdy_certify_date,
                                jobType = project.job_type;
                            if (category == constants.CERTIFIED) {
                                temp = [division, empId, jobType, empFullName, wdy_date, phone, hos, tos, certifyDate, outlaw];
                            } else {
                                temp = [division, empId, jobType, empFullName, wdy_date, phone, hos, tos, outlaw];
                            }
                        } else if (category == constants.FRA_REPORT || category == constants.ADMIN_HOS_LOG) {

                            let empId = project.demp_display_Id,
                                empFullName = project.emp_full_name, wdy_date = project.wdy_date,
                                phone = project.wdy_emp_phone_numbers,
                                hos = project.wdy_certify_status == constants.CERTIFIED ? project.wdy_working_time_hos_adjust : '',
                                certifyDate = project.wdy_certify_date && project.wdy_certify_status == constants.CERTIFIED ? project.wdy_certify_date : '',
                                jobType = project.job_type,
                                comments = project.wdy_comments,
                                status = this.getStatus(project);

                            //["Employee ID","Employee Name", "Service Date", "Job Type", "Phone", "HOS","Certify Date"]
                            temp = [empId, empFullName, wdy_date, jobType, hos, certifyDate, comments, status];

                        } else if (category == constants.SERIES14) {

                            let empId = project.EmployeeId,
                                empFullName = project.emp_full_name, wdy_date = moment(project.WorkDate).format("MM/DD/YYYY"),
                                series14 = project.series_14,
                                series6 = project.series_6,
                                jobType = project.Type;
                            temp = [empId, empFullName, wdy_date, jobType, series14, series6];
                        } else {

                            let empId = project.demp_display_Id, jobType = project.job_type,
                                empFullName = project.emp_full_name, wdy_date = project.wdy_date,
                                systemHOS = project.wdy_spread, systemTOS = project.wdy_working_time_hos,
                                adjustedHOS = project.wdy_spread_adjust, adjustTOS = project.wdy_working_time_hos_adjust,
                                differentialHOS = project.wdy_spread_adjust, differentialTOS = project.wdy_working_time_hos_adjust,
                                claimDate = project.wdy_claim_date;
                            temp = [division, empId, jobType, empFullName, wdy_date, systemHOS, systemTOS, adjustedHOS, adjustTOS, differentialHOS, differentialTOS, claimDate];
                        }

                        printRows.push(temp);

                    });
                }
            }
            // creating table for pdf
            function createTable(columns, rows) {
                let marginFromTop = 100;
                if (empRole == constants.roles.EMPLOYEE_ROLE) {
                    marginFromTop = 140
                }
                let columnStyles = {
                    id: { fillColor: 255 },
                    4: { cellWidth: 60 }
                }
                if (category == constants.AUDIT_TRAIL) {
                    columnStyles = {
                        1: { cellWidth: 50 },
                        2: { cellWidth: 80 },
                        3: { cellWidth: 120 },
                        4: { cellWidth: 150 },
                        5: { cellWidth: 150 }
                    }
                }
                else if (category == constants.FRA_REPORT || category == constants.ADMIN_HOS_LOG) {
                    columnStyles = {
                        id: { fillColor: 255 },

                    }
                }
                else if (category == constants.MANUALLY_UPDATE || category == constants.PENDING_CLAIM || category == constants.ACCEPTED_CLAIM) {
                    columnStyles = {
                        0: { cellWidth: 60 },
                        5: { cellWidth: 60 },
                        6: { cellWidth: 60 },
                        7: { cellWidth: 60 },
                        8: { cellWidth: 60 },
                        9: { cellWidth: 63 },
                        10: { cellWidth: 63 }
                    };
                }
                autoTable(doc, {
                    columns: columns,
                    body: rows,
                    margin: { top: 80 },
                    columnStyles: columnStyles,
                    startY: marginFromTop,
                    showHead: 'everyPage',
                    pageBreak: 'auto',
                    headStyles: {
                        cellWidth: 'wrap',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        overflow: 'linebreak',
                    },
                    alternateRowStyles: { fillColor: 240 },
                    theme: 'striped',
                    styles: { overflow: 'linebreak' },
                    didDrawPage: function (data) {
                        header();
                        footer();
                    }
                });
            }
            doc.text(40, 80, pageTitle);
            if (this.props.authDetails.role == constants.roles.EMPLOYEE_ROLE) {
                let empId = this.props.authDetails.employeeID,
                    empNameArr = this.props.authDetails.name.split('.');                    
                    let empName = empNameArr[0] + " " + (empNameArr.length > 1 ? empNameArr[1]:"");
                doc.setFontSize(empDetailsFontSize);
                doc.text(40, 105, "Name - " + empName);
                doc.text(40, 125, "ID - " + empId);
            }
            createTable(printColumns, printRows, false);
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp);
            }

            //Header
            function header() {
                img.addEventListener('load', function () { });
                img.src = keolisLogo;
                doc.addImage(img, 'PNG', 17, 10, 163.8, 34.80);
                doc.setDrawColor(234, 162, 11);
                doc.line(15, 50, doc.internal.pageSize.width - 15, 50);
                doc.line(15, 52, doc.internal.pageSize.width - 15, 52);
            }

            //Footer
            function footer() {
                let str = 'Page ' + doc.internal.getNumberOfPages();
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' of ' + totalPagesExp;
                }
                doc.setDrawColor(234, 162, 11);
                doc.line(15, doc.internal.pageSize.height - 40, doc.internal.pageSize.width - 15,
                    doc.internal.pageSize.height - 40);
                doc.setTextColor(0, 60, 119);
                doc.setFontSize(9);
                var current_time = new moment().format("hh:mm:ss");
                doc.text(20, doc.internal.pageSize.height - 20, today + "  " + current_time);
                doc.text(doc.internal.pageSize.width - 80, doc.internal.pageSize.height - 20, str);
            }
            doc.save(printTitle + '.pdf');
            this.setState({
                printStatus: false
            });
            callback();    

        }
        );

        
    }   
}


function mapStateToProps(state) {
    return { 
        PaginationState: state.Pagination, 
        filterState:state.filter,
        authDetails:state.authState,
        printState:state.printState,
        workday: state.workday.workday,
        showModal: state.modals.showModal
     };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        printProgress:actions.printProgressAction,
        fetchDataToPrint:actions.fetchDataToPrintAction,
        onActErr: actions.actErrorAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(PDFPrinting);


